<template>
  <div class="animated fadeIn">
    <b-breadcrumb><strong>Style List</strong></b-breadcrumb>

    <b-row>
      <div class="design-container-details__main">
        <div class="col-md-12 ">
          <b-col sm="12" class="text-right">
            <p class="mt-2">
              <b style="margin-right:5%"
                >Total Records :<span style="color:red;">
                  {{ totalcount }}
                </span></b
              >
            </p>
          </b-col>

          <b-col class="col-md-12 ipad">
            <b-table
              caption-top
              show-empty
              stacked="md"
              :busy="isBusy"
              :items="items"
              :fields="fields1"
              :bordered="true"
              :current-page="currentPage"
              :perPage="perPage"
            >
              <template slot="action" slot-scope="row">
                <b-col md="12" class="pull-right text-right">
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template v-slot:button-content>
                      <span class="cui-options icons font-1xl d-block"></span>
                    </template>

                    <b-dropdown-item>
                      <span
                        v-b-modal.Detailsprotomodel
                        @click="editinfoModal(row.item)"
                      >
                        Show Details
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </template>
            </b-table>

            <b-col md="6" class="my-1">
              <paginate
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              >
              </paginate>
            </b-col>
          </b-col>
        </div>
      </div>
    </b-row>

    <!-- Code for Edit  -->
    <b-modal
      title="Allocate Inspection"
      v-model="allocate_inspection"
      @ok="allocate_inspection = false"
      size="xl"
    >
      <template slot="modal-header" slot-scope="{ close }">
        <h5>Allocate Inspection</h5>
        <b-form-group style="float:right;">
          <b-button variant="danger" @click="editcancel()"
            ><i class="fa fa-times"></i
          ></b-button>
        </b-form-group>
      </template>

      <template slot="default" slot-scope="{ hide }">
        <div>
          <b-card no-body>
            <b-tabs pills card>
              <b-tab title="Style Detail Information" active>
                <b-card-text>
                  <!-- INFORMATION TAB STARTS HERE -->

                  <b-row>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Style Name :</b></label>
                        </b-col>

                        <b-col md="12" class="pull-right titleb"
                          >{{ selected_inspection_data.style_name }}
                        </b-col>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Style Code :</b></label>
                        </b-col>
                        <!-- -->
                        <b-col md="12" class="pull-right titleb"
                          >{{ selected_inspection_data.style_code }}
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Style Color :</b></label>
                        </b-col>
                        <!-- -->
                        <b-col md="12" class="pull-right titleb"
                          >{{ selected_inspection_data.color }}
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Product Description :</b></label>
                        </b-col>
                        <!-- -->
                        <b-col md="12" class="pull-right titleb">
                          {{ selected_inspection_data.style_description }}
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Buyer Name :</b></label>
                        </b-col>
                        <!-- -->
                        <b-col md="12" class="pull-right titleb"
                          >{{ selected_inspection_data.buyer_name }}
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Vendor Name :</b></label>
                        </b-col>
                        <!-- -->
                        <b-col md="12" class="pull-right titleb"
                          >{{ selected_inspection_data.vendor_name }}
                        </b-col>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>PO no. :</b></label>
                        </b-col>

                        <b-col md="12" class="pull-right titleb"
                          >{{ selected_inspection_data.po_id }}
                        </b-col>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Brand Name :</b></label>
                        </b-col>

                        <b-col md="12" class="pull-right titleb">
                          {{ selected_inspection_data.brand_title }}
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Location :</b></label>
                        </b-col>

                        <b-col
                          v-if="
                            selected_inspection_data.location != null ||
                              selected_inspection_data.location != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.location }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.location == null ||
                              selected_inspection_data.location == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row
                    v-if="
                      selected_inspection_data.inspection_status ==
                        'Requested' &&
                        (user_type == 'Brand_Manager' || user_type == 'Buyer')
                    "
                  >
                    <b-form
                      @submit.prevent="validateForm4('form-5')"
                      data-vv-scope="form-5"
                    >
                      <b-col md="12">
                        <b-form-group>
                          <b-col md="8" class="pull-left">
                            <label for="actionforapproveqc"
                              ><b>Action</b>
                              <span style="color:red;">*</span>
                            </label>
                          </b-col>
                          <b-col class="d-flex flex-flow" md-4>
                            <b-form-select
                              v-model="actionforapproveqc"
                              :options="options2"
                              id="actionforapproveqc"
                              name="actionforapproveqc"
                              required
                            >
                            </b-form-select>

                            <b-form-input
                              type="text"
                              :value="selected_inspection_data.inspection_id"
                              v-model="inspection_id"
                              hidden
                            >
                            </b-form-input>

                            <b-button
                              type="submit"
                              class="ml-2 col-md-4"
                              variant="primary"
                              >Submit</b-button
                            >
                          </b-col>
                        </b-form-group>
                      </b-col>
                    </b-form>
                  </b-row>

                  <b-row
                    class=""
                    v-if="
                      selected_inspection_data.inspection_status == 'RFT' ||
                        selected_inspection_data.inspection_status == 'Hold'
                    "
                  >
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>MRP :</b></label>
                        </b-col>

                        <b-col
                          v-if="
                            selected_inspection_data.mrp != null ||
                              selected_inspection_data.mrp != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.mrp }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.mrp == null ||
                              selected_inspection_data.mrp == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Total Quantity :</b></label>
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.total_quantity != null ||
                              selected_inspection_data.total_quantity != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.total_quantity }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.total_quantity == null ||
                              selected_inspection_datatotal_quantity == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Inspected Quantity :</b></label>
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.inspection_quantity !=
                              null ||
                              selected_inspection_data.inspection_quantity != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.inspection_quantity }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.inspection_quantity ==
                              null ||
                              selected_inspection_data.inspection_quantity == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                        <!-- <b-col md="12" class="pull-right titleb">{{inspection_quantity}}
                        </b-col> -->
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Passed Quantity :</b></label>
                        </b-col>

                        <b-col
                          v-if="
                            selected_inspection_data.passed_quantity != null ||
                              selected_inspection_data.passed_quantity != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.passed_quantity }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.passed_quantity == null ||
                              selected_inspection_data.passed_quantity == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{passed_quantity}}
                        </b-col> -->
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"
                            ><b>Rc/Reject/Defect Quantity :</b></label
                          >
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{reject_quantity}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.reject_quantity != null ||
                              selected_inspection_data.reject_quantity != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.reject_quantity }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.reject_quantity == null ||
                              selected_inspection_data.reject_quantity == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"
                            ><b>No. of Carton Inspected :</b></label
                          >
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{carton_inspected}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.carton_inspected != null ||
                              selected_inspection_data.carton_inspected != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.carton_inspected }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.carton_inspected == null ||
                              selected_inspection_data.carton_inspected == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Inspection Type :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{inspection_type}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.inspection_type != null ||
                              selected_inspection_data.inspection_type != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.inspection_type }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.inspection_type == null ||
                              selected_inspection_data.inspection_type == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Inspection Process :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{inspection_process}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.inspection_process !=
                              null ||
                              selected_inspection_data.inspection_process != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.inspection_process }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.inspection_process ==
                              null ||
                              selected_inspection_data.inspection_process == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Stitching Quality :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{stiching_quality}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.stiching_quality != null ||
                              selected_inspection_data.stiching_quality != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.stiching_quality }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.stiching_quality == null ||
                              selected_inspection_data.stiching_quality == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Wash Care Label :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{wash_lable}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.wash_lable != null ||
                              selected_inspection_data.wash_lable != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.wash_lable }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.wash_lable == null ||
                              selected_inspection_data.wash_lable == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Hang Tag :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{hand_teg}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.hand_teg != null ||
                              selected_inspection_data.hand_teg != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.hand_teg }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.hand_teg == null ||
                              selected_inspection_data.hand_teg == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Main Label :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{main_label}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.main_label != null ||
                              selected_inspection_data.main_label != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.main_label }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.main_label == null ||
                              selected_inspection_data.main_label == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Size Label :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{size_label}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.size_label != null ||
                              selected_inspection_data.size_label != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.size_label }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.size_label == null ||
                              selected_inspection_data.size_label == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Fabric Color :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{fabric_color}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.fabric_color != null ||
                              selected_inspection_data.fabric_color != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.fabric_color }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.fabric_color == null ||
                              selected_inspection_data.fabric_color == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Fabric Quality :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{fabric_quality}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.fabric_quality != null ||
                              selected_inspection_data.fabric_quality != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.fabric_quality }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.fabric_quality == null ||
                              selected_inspection_data.fabric_quality == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Print Quality :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{print_quality}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.print_quality != null ||
                              selected_inspection_data.print_quality != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.print_quality }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.print_quality == null ||
                              selected_inspection_data.print_quality == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Embroidery :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{embroidery}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.embroidery != null ||
                              selected_inspection_data.embroidery != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.embroidery }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.embroidery == null ||
                              selected_inspection_data.embroidery == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"
                            ><b>Button Hole/Attachment :</b></label
                          >
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{button_hole}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.button_hole != null ||
                              selected_inspection_data.button_hole != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.button_hole }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.button_hole == null ||
                              selected_inspection_data.button_hole == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>Barcode With MRP :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{barcode_mrp}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.barcode_mrp != null ||
                              selected_inspection_data.barcode_mrp != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.barcode_mrp }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.barcode_mrp == null ||
                              selected_inspection_data.barcode_mrp == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"
                            ><b>Over Lock Stitch Quality :</b></label
                          >
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{overlook_quality}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.overlook_quality != null ||
                              selected_inspection_data.overlook_quality != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.overlook_quality }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.overlook_quality == null ||
                              selected_inspection_data.overlook_quality == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"><b>GPT :</b></label>
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{gpt}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.gpt != null ||
                              selected_inspection_data.gpt != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.gpt }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.gpt == null ||
                              selected_inspection_data.gpt == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"
                            ><b
                              >Checked Against Size Chart (Within / Out of )
                              Tolerance :</b
                            ></label
                          >
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{size_chart}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.size_chart != null ||
                              selected_inspection_data.size_chart != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.size_chart }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.size_chart == null ||
                              selected_inspection_data.size_chart == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <label for="name"
                            ><b
                              >Checked Against PP Sample/Comments Sheet :</b
                            ></label
                          >
                        </b-col>

                        <!-- <b-col md="12" class="pull-right titleb">{{check_pp_sample}}
                        </b-col> -->
                        <b-col
                          v-if="
                            selected_inspection_data.check_pp_sample != null ||
                              selected_inspection_data.check_pp_sample != ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >{{ selected_inspection_data.check_pp_sample }}
                        </b-col>
                        <b-col
                          v-if="
                            selected_inspection_data.check_pp_sample == null ||
                              selected_inspection_data.check_pp_sample == ''
                          "
                          md="12"
                          class="pull-right titleb"
                          >NA
                        </b-col>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <div slot="footer" class="text-right mt-12">
                    <!-- <a
                      :href="selected_inspection_data.report_file_path"
                      target="_blank"
                      download
                    >
                     
                      <b-button
                        type="submit"
                        class="mr-2"
                        variant="success"
                        v-if="
                          selected_inspection_data.inspection_status !=
                            'Pending' &&
                            selected_inspection_data.inspection_status !=
                              'Approved' &&
                            selected_inspection_data.inspection_status !=
                              'Scheduled'
                        "
                        >Download</b-button
                      >
                    </a> -->
                    <b-button variant="danger" @click="editcancel()"
                      >cancel</b-button
                    >
                  </div>
                </b-card-text>
              </b-tab>

              <!-- ~~~~~INFORAMTION TAB ENDS HERE~~~~~~~ -->

              <!-- ~~~~~~~~~~~~~ COMMENT TAB~~~~~~~~~~~~~~ -->
              <b-tab
                title="Comments"
                v-if="
                  selected_inspection_data.inspection_status != 'Pending' &&
                    selected_inspection_data.inspection_status != 'Approved' &&
                    selected_inspection_data.inspection_status != 'Scheduled' &&
                    selected_inspection_data.inspection_status != 'Other' &&
                    selected_inspection_data.inspection_status != 'Cancel'
                "
              >
                <b-card-text>
                  <b-row
                    v-for="comment_item in comment_details"
                    :key="comment_item"
                  >
                    <b-col md="12">
                      <b-form-group>
                        <b-col md="12" class="pull-left">
                          <!-- <label for="name"><b>{{comment_label}}:</b></label> -->
                        </b-col>
                        <b-col
                          >{{ comment_item.defect_type }} -
                          {{ comment_item.message }}
                        </b-col>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>

              <!-- ~~~~~~~~~~~~~~ Comment sab ends  ~~~~~~~~~~~~~~~~~~~-->

              <!-- ~~~~~~~~~~~~ Image tab starts ~~~~~~~~~~~~~~~~~~~~~ -->

              <b-tab
                title="Images"
                v-if="
                  selected_inspection_data.inspection_status != 'Pending' &&
                    selected_inspection_data.inspection_status != 'Approved' &&
                    selected_inspection_data.inspection_status != 'Scheduled' &&
                    selected_inspection_data.inspection_status != 'Other' &&
                    selected_inspection_data.inspection_status != 'Cancel'
                "
              >
                <div
                  class="accordion"
                  role="tablist"
                  v-for="(image_item, index) in image_details"
                  :key="image_item"
                >
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button
                        block
                        v-b-toggle="'accordion' + index"
                        variant="light"
                        style="text-align: left;"
                        >{{ image_item.image_type }}</b-button
                      >
                    </b-card-header>
                    <b-collapse
                      :id="'accordion' + index"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body class="mt-3">
                        <p
                          class="ml-3"
                          v-if="
                            image_item.image_path == null ||
                              image_item.image_path == ''
                          "
                        >
                          No Data
                        </p>

                        <img
                          v-for="image in image_item.image_path"
                          :src="image"
                          :key="image"
                          @click="openimage(image)"
                          height="100px"
                          width="100px"
                          style="padding:5px; cursor: pointer;"
                        />
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-tab>

              <!-- ~~~~~~~~~~~~~~Image tab ends ~~~~~~~~~~~~~~~~~~~~~~~ -->
            </b-tabs>
          </b-card>
        </div>

        <template slot="modal-footer" slot-scope="{ hide }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
        </template>
      </template>
    </b-modal>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
const axios = require("axios");
export default {
  data() {
    return {
      isBusy: false,
      items: [],
      fields1: [
        { key: "style_code", label: "Style Code" },
        { key: "brand_title", label: "Brand Bitle" },
        { key: "location", label: "Location" },
        { key: "offered_quantity", label: "Offered Quantity" },
        { key: "vendor_name", label: "Vendor Name" },
        { key: "inspection_date", label: "Inspection Date" },
        { key: "zone", label: "zone" },
        { key: "inspection_flag", label: "Inspection Type" },
        { key: "action", label: "Action" },
      ],

      access_token: "",
      user_email: "",
      user_type: "",
      route_id: "",
      route_status: "",
      pageNo: 1,
      totalcount: "",
      currentPage: 1,
      perPage: 10,
      noofpages: "",
      selected_inspection_data: {},
      inspection_id: "",
      allocate_inspection: false,
    };
  },

  created: function() {
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
    this.access_token = userInfo[0]["token"];
    axios.defaults.headers.common["x-access-token"] = this.access_token;
    axios.defaults.headers.common["Content-Type"] =
      "application/json;charset=UTF-8";
    axios.defaults.headers.common["Accept"] = "application/json";
    axios.defaults.headers.common["Origin"] = "http://localhost:8080";
    this.user_email = userInfo[0].email_id;
    this.user_type = userInfo[0].user_type;
    this.route_id = this.$route.params.id;
    const myArr = this.route_id.split(",");
    // const mysubcatArr = this.route_id;
    console.log("Myarr", myArr);
    this.route_status = myArr[0];
    console.log("HHHHHH", this.route_status);

    this.getListFOrQC(this.pageNo);
  },

  methods: {
    getListFOrQC: function(pageNo) {
      //   this.isBusy = true;
      const Obj = {
        pageno: pageNo,
        inspectionstatus: this.route_status,
      };

      axios
        .post(
          `${CONSTANTS.API_URL}/getInspectionListingForQCAgainstStatus`,
          Obj
        )
        .then((response) => {
          if (response.data.returnmsg === "Successful") {
            this.items = response.data.returnvalue;
            this.totalcount = response.data.totalcount;

            this.noofpages = parseInt(this.totalcount) / 10;

            this.noofpages = Math.ceil(this.noofpages);
            // this.isBusy = !this.isBusy;
          } else {
            this.isBusy = false;
            this.items = [];
            this.totalcount = 0;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    clickCallback(pageNo) {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.getListFOrQC(pageNo);
    },

    editinfoModal: function(value) {
      // console.log("fFFFFFFFFFFFFFFFFFFFFFFFFFF", value)
      (this.selected_inspection_data = value),
        (this.inspection_id = value.inspection_id),
        (this.allocate_inspection = !this.allocate_inspection);
      this.getinspectioncomment();
      this.getinspectionimages();
    },

    editcancel: function() {
      this.allocate_inspection = !this.allocate_inspection;
    },

    getinspectioncomment: function() {
      // alert(this.inspection_id );
      const Obj = {
        inspection_id: this.inspection_id,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getinspectioncomment`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === "Successful") {
            this.comment_details = response.data.returnvalue;
            // console.log(this.comment_details[0].message,"this.comment_details")
          } else {
            this.comment_details = [];
          }
        })

        .catch((e) => {
          this.errors.push(e);
        });
    },

    getinspectionimages: function() {
      const Obj = {
        inspection_id: this.inspection_id,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getinspectionimages `, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === "Successful") {
            this.image_details = response.data.returnvalue;
            console.log(this.image_details, "this.this.image_details");
          } else {
            this.image_details = [];
          }
        })

        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>
